/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConfirmSpaceUserParams,
  GetClientSpacesParams,
  GetLatestSpacesParams,
  GetSpaceEventsParams,
  RequestSpacesConfirmSpaceUserRequest,
  RequestSpacesCreateSpaceUserRequest,
  RequestSpacesSpaceEventRequest,
  ResponseSpacesGetClientSpaceResponse,
  ResponseSpacesGetClientSpaceResponsePaginated,
  ResponseSpacesSpaceResponse,
  ResponseSpacesSpaceUserResponse,
  ResponseTwoFactorNotEnforcedGetSpaceEventResponse,
  ResponseTwoFactorNotEnforcedGetSpaceEventResponsePaginated,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Spaces<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Spaces
   * @name CancelUserSpaceRegistration
   * @summary Unsubscribe user from space (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request DELETE:/api/v1/spaces/{spaceId}
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  cancelUserSpaceRegistration = (spaceId: string, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/spaces/${spaceId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Spaces
   * @name ConfirmSpaceUser
   * @summary The endpoint to get confirm a space registration (Auth)
   * @request POST:/api/v1/spaces/confirm
   * @secure
   * @response `200` `ResponseSpacesSpaceUserResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  confirmSpaceUser = (
    query: ConfirmSpaceUserParams,
    data: RequestSpacesConfirmSpaceUserRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseSpacesSpaceUserResponse, void>({
      path: `/api/v1/spaces/confirm`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Spaces
   * @name GetClientSpace
   * @summary Get the space for a given user (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/spaces/{spaceId}
   * @secure
   * @response `200` `ResponseSpacesGetClientSpaceResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientSpace = (spaceId: string, params: RequestParams = {}) =>
    this.http.request<ResponseSpacesGetClientSpaceResponse, void>({
      path: `/api/v1/spaces/${spaceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Spaces
   * @name GetClientSpaces
   * @summary Get all spaces for a given user (Auth policies: HostOrSupportOrExpertPolicy)
   * @request GET:/api/v1/spaces/client/{clientId}
   * @secure
   * @response `200` `ResponseSpacesGetClientSpaceResponsePaginated` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientSpaces = (
    { clientId, ...query }: GetClientSpacesParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseSpacesGetClientSpaceResponsePaginated, void>({
      path: `/api/v1/spaces/client/${clientId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Spaces
   * @name GetLatestSpaces
   * @summary  (Auth policies: ClientOrExpertPolicy)
   * @request GET:/api/v1/spaces/upcoming
   * @secure
   * @response `200` `(ResponseSpacesSpaceResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getLatestSpaces = (
    query: GetLatestSpacesParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseSpacesSpaceResponse[], void>({
      path: `/api/v1/spaces/upcoming`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Spaces
   * @name GetSpaceEvent
   * @summary  (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/spaces/space-events/{id}
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedGetSpaceEventResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getSpaceEvent = (id: string, params: RequestParams = {}) =>
    this.http.request<ResponseTwoFactorNotEnforcedGetSpaceEventResponse, void>({
      path: `/api/v1/spaces/space-events/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Spaces
   * @name GetSpaceEvents
   * @summary  (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request POST:/api/v1/spaces/space-events
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedGetSpaceEventResponsePaginated` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getSpaceEvents = (
    query: GetSpaceEventsParams,
    data: RequestSpacesSpaceEventRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ResponseTwoFactorNotEnforcedGetSpaceEventResponsePaginated,
      void
    >({
      path: `/api/v1/spaces/space-events`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags WordpressSpaces
 * @name RegisterUnconfirmedSpaceUser
 * @summary An endpoint to create an unconfirmed space user
Authenticated using the OpenUp Website API Key
 * @request PUT:/api/v1/spaces/user
 * @secure
 * @response `200` `void` OK
 */
  registerUnconfirmedSpaceUser = (
    data: RequestSpacesCreateSpaceUserRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/api/v1/spaces/user`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
